import React, { useState } from "react";
import { useRouteMatch, NavLink, Link, Redirect } from "react-router-dom";
import { FaTwitter, FaGithub, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const links = [
  {
    title: "Home",
    path: "home",
  },

  {
    title: "About Me",
    path: "aboutme",
  },
  {
    title: "Projects",
    path: "projects",
  },
  {
    title: "Photography",
    path: "photography",
  },
  {
    title: "Contact",
    path: "contact",
  },
];

const Header = () => {
  let { url } = useRouteMatch();

  const [displaySidenav, setDisplaySidenav] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setDisplaySidenav(!displaySidenav);
  };

  return (
    <>
      <header className="app-header app-header-1">
        <div className="header-logo">
          <Link to={`home`.replace(/([^:])(\/\/+)/g, "$1/Home")}>Stephen Koy</Link>
        </div>
        <button className="button button-menu" onClick={(e) => handleClick(e)}>
          <span></span>
        </button>
        <ul className="header-menu">
          {links.map((item, index) => (
            <li key={index}>
              <NavLink to={`${url}${item.path}`} activeClassName="active">
                <span className="anchor">{item.title}</span>
              </NavLink>
            </li>
          ))}
        </ul>
        <div className="header-follow">
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/stephenkoy/">
                <i className="ti-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="https://github.com/StephenKoy/">
                <i className="ti-github"></i>
              </a>
            </li>
            <li>
              <a href="https://www.twitter.com/s_koyfish">
                  <i className="ti-twitter-alt"></i>
              </a>
            </li>
          </ul>
          <p>Follow Me</p>
        </div>
      </header>
      <div className={`app-sidenav ${displaySidenav && "active"}`}>
        <div className="sidenav-menu">
          <div className="logo">
            <Link to={`home`.replace(/([^:])(\/\/+)/g, "$1/")}>Stephen Koy</Link>
          </div>
          <button className="button" onClick={(e) => handleClick(e)}></button>
          <ul className="sidenav-nav">
            {links.map((item, index) => (
              <li key={index} onClick={(e) => handleClick(e)}>
                <NavLink
                  to={`${url}${item.path}`.replace(/([^:])(\/\/+)/g, "$1/")}
                  activeClassName="active"
                >
                  <span className="anchor">{item.title}</span>
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="sidenav-links">
            <ul>
              <li>
                <a href="https://www.linkedin.com/in/stephenkoy/">
                  <FaTwitter className="icon" />
                </a>
              </li>
              <li>
                <a href="https://github.com/StephenKoy/">
                  <FaGithub className="icon" />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/stephenkoy/">
                  <FaLinkedinIn className="icon" />
                </a>
              </li>
            </ul>
            <p>Follow Me</p>
          </div>
        </div>
        <span className="sidenav-close" />
      </div>
    </>
  );
};

export default Header;
